import type {IAsset} from '@netx/core-asset-next/schema';
import {
	assetPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';

export const canManageAssetViews = (asset?: IAsset): boolean => {
	if (!asset) return false;
	if (!currentUserMeetsUserLevel(UserLevel.PRODUCER)) return false;
	if (asset.readOnly) return false;
	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.MODIFY,
		permissionName: PermissionName.MANAGE_VIEWS,
	});
};
